// extracted by mini-css-extract-plugin
export default {"tooltip":"OO-z","arrow":"PO-z"};